import React from 'react';
import styled, { DefaultTheme } from 'styled-components';
import { TabList, Tab, TabPanel } from 'react-tabs';

import { TabsProps } from './Tabs.types';

export const STabListWrapper = styled.div<Pick<TabsProps, 'borderBottom' | 'showTabsList'>>`
  display: flex;
  border-bottom: ${(props) => props.borderBottom};
  visibility: ${(props) => (props.showTabsList ? 'visible' : 'hidden')};
  height: ${(props) => (props.showTabsList ? 'auto' : 0)};

  &::-webkit-scrollbar {
    display: none;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    flex-direction: column;
    gap: 24px;
  }
`;

export const STabList = styled((props) => <TabList {...props} />)`
  list-style-type: none;
  padding: 0;
  display: flex;
  margin: 0;
  border: none;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const STab = styled((props) => <Tab {...props} />)<{ defaulttheme: DefaultTheme }>`
  ${({ defaulttheme }) => `
      margin-right: 24px;
      border: none;
      padding: 0 0 12px 0;
      user-select: none;
      cursor: pointer;
      white-space: nowrap;
      border-bottom: 2px solid transparent;
      transition: all 0.5s ease-in;
      color: ${defaulttheme.colors.text.secondary};
    
      &.is-selected {
        color: ${defaulttheme.colors.text.primary};
        border-bottom: 2px solid ${defaulttheme.colors.palette.primary};
      }
    
      &:focus {
        outline: none;
        box-shadow: none;
      }
    
      * {
        cursor: pointer;
      }
  `}
`;

export const STabPanel = styled((props) => <TabPanel {...props} />)`
  display: none;
  border: none;
  margin-top: 24px;

  &.is-selected {
    display: flex;
    width: 100%;
    border: none;
  }
`;

export const RightElementWrapper = styled.div`
  display: flex;
  margin-left: auto;

  ${({ theme }) => theme.mediaQueries.md} {
    margin: unset;
  }
`;
